import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config';
import { GET_BENEFITS_GAMEFICATION_POINT, GET_BENEFITS_GAMEFICATION_POINT_SUCCESS, GET_BENEFITS_GAMEFICATION_POINT_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getBenefitsGamificationPoint({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/get-client-inventories`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BENEFITS_GAMEFICATION_POINT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BENEFITS_GAMEFICATION_POINT_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BENEFITS_GAMEFICATION_POINT_ERROR, payload: error });
  }
}

export function* watchgetBenefitsGamificationPoint() {
  yield takeEvery(GET_BENEFITS_GAMEFICATION_POINT, getBenefitsGamificationPoint);
}

function* getBenefitsGamificationPointSaga() {
  yield all([fork(watchgetBenefitsGamificationPoint)]);
}

export default getBenefitsGamificationPointSaga;
